import { motion } from "framer-motion";
import { Bot, FileText, TrendingUp, AlertCircle, CheckCircle } from "lucide-react";

interface Activity {
  id: string;
  type: "optimization" | "scan" | "alert" | "success";
  message: string;
  timestamp: string;
  page?: string;
}

const activities: Activity[] = [
  {
    id: "1",
    type: "optimization",
    message: "Am optimizat pagina 'Pantofi Sport' pentru trendul 'reduceri iarnă 2024'",
    timestamp: "Acum 5 minute",
    page: "/pantofi-sport",
  },
  {
    id: "2",
    type: "success",
    message: "Schema Markup adăugat cu succes pe 15 pagini de produse",
    timestamp: "Acum 23 minute",
  },
  {
    id: "3",
    type: "scan",
    message: "Scan zilnic finalizat - 3 noi oportunități GEO detectate",
    timestamp: "Acum 1 oră",
  },
  {
    id: "4",
    type: "alert",
    message: "Competitor 'competitor-a.ro' a depășit scorul tău GEO",
    timestamp: "Acum 2 ore",
  },
  {
    id: "5",
    type: "optimization",
    message: "Meta description actualizată pentru 'Haine Bărbați'",
    timestamp: "Acum 3 ore",
    page: "/haine-barbati",
  },
  {
    id: "6",
    type: "success",
    message: "Citare detectată în răspuns ChatGPT pentru 'cele mai bune pantofi sport'",
    timestamp: "Acum 5 ore",
  },
];

const iconMap = {
  optimization: Bot,
  scan: FileText,
  alert: AlertCircle,
  success: CheckCircle,
};

const colorMap = {
  optimization: "bg-primary/10 text-primary",
  scan: "bg-blue-500/10 text-blue-500",
  alert: "bg-yellow-500/10 text-yellow-600",
  success: "bg-green-500/10 text-green-600",
};

export function ActivityLog() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4 }}
      className="card-elevated"
    >
      <div className="p-6 border-b border-border">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          <h3 className="text-lg font-semibold text-foreground">
            Activitate AI Live
          </h3>
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          Ultimele acțiuni ale AI-ului pe site-ul tău
        </p>
      </div>

      <div className="divide-y divide-border max-h-[400px] overflow-y-auto">
        {activities.map((activity, index) => {
          const Icon = iconMap[activity.type];
          const colorClass = colorMap[activity.type];

          return (
            <motion.div
              key={activity.id}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.1 * index }}
              className="p-4 hover:bg-muted/50 transition-colors"
            >
              <div className="flex gap-3">
                <div
                  className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${colorClass}`}
                >
                  <Icon className="w-4 h-4" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground">{activity.message}</p>
                  {activity.page && (
                    <p className="text-xs text-primary mt-0.5">
                      {activity.page}
                    </p>
                  )}
                  <p className="text-xs text-muted-foreground mt-1">
                    {activity.timestamp}
                  </p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </motion.div>
  );
}
